import { Card, Typography, Box } from '@mui/material';

const ColorwayCard = ({ colorway, onClick }) => {
  return (
    <Card
      variant="outlined"
      onClick={onClick}
      sx={{
        cursor: 'pointer',
        '&:hover': { boxShadow: 1 },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        p: 2
      }}
    >
      <Typography variant="h6" sx={{ mb: 1 }}>
        {colorway.name}
      </Typography>
      <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
        {colorway.chromas &&
          colorway.chromas.map((color, index) => (
            <Box
              key={index}
              sx={{
                width: 16,
                height: 16,
                backgroundColor: color.color,
                border: '1px solid #ccc'
              }}
            />
          ))}
      </Box>
    </Card>
  );
};

export default ColorwayCard;
